const initialState = {
  sortBy: { filterName: "Sort By", filterOptionName: "", value: "" },
  priceRange: { filterName: "Price Range", range: null },
  nutritionalFact: {
    calories: null,
    carbs: null,
    fats: null,
    protein: null,
    dietaryRestrictions: [],
  },
  availableProducts: false,
  filtersSelected: [],
  selectedCategories: [],
  fetchedCategories: [],
  loading: false,
  allProductPriceRange: null,
  allProductNutritionFact: null,
  storeFilters: null,
  fetchLoading: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "APPLY_PRODUCT_FILTER": {
      return {
        ...state,
        filtersSelected: payload.filtersToApply,
        sortBy: payload.sortOption,
        priceRange: {
          filterName: "Price Range",
          range: payload.priceRangeToApply,
        },
        selectedCategories: payload.selectedCategories,
        availableProducts: payload.availableProducts,
        nutritionalFact:
          payload.nutritionalFact === null
            ? {
                calories: null,
                carbs: null,
                fats: null,
                protein: null,
                dietaryRestrictions: [],
              }
            : payload.nutritionalFact,
      };
    }
    case "CLEAR_PRODUCT_FILTER": {
      return {
        ...state,
        filtersSelected: [],
        sortBy: { filterName: "", filterOptionName: "", value: "" },
        priceRange: { filterName: "Price Range", range: null },
        availableProducts: false,
        nutritionalFact: {
          calories: null,
          carbs: null,
          fats: null,
          protein: null,
          dietaryRestrictions: [],
        },
      };
    }
    case "DELETE_PRODUCT_FILTER": {
      return {
        ...state,
        filtersSelected: state.filtersSelected.filter(
          (item) => item.value !== payload.value
        ),
      };
    }
    case "DELETE_AVAILABLE_PRODUCT": {
      return {
        ...state,
        availableProducts: false,
      };
    }
    case "CLEAR_SORT_BY": {
      return {
        ...state,
        sortBy: { filterName: "", filterOptionName: "", value: "" },
      };
    }
    case "CLEAR_PRICE_RANGE": {
      return {
        ...state,
        priceRange: { filterName: "Price Range", range: null },
      };
    }

    case "CHECK_CATEGORIES": {
      const { selectedCategories } = state;
      const newCategories = [];
      selectedCategories.forEach((category) => {
        const categoryIndex = payload.findIndex((item) => item.id === category);
        if (categoryIndex !== -1) {
          newCategories.push(category);
        }
      });
      return {
        ...state,
        selectedCategories: newCategories,
      };
    }
    case "DELETE_CATEGORY": {
      return {
        ...state,
        selectedCategories: state.selectedCategories.filter(
          (item) => item !== payload.value
        ),
      };
    }
    case "SET_FETCH_CATEGORY": {
      return {
        ...state,
        fetchedCategories: payload,
      };
    }
    case "SET_LOADING": {
      return {
        ...state,
        loading: payload,
      };
    }
    case "SET_FETCH_FILTERS_LOADING": {
      return {
        ...state,
        fetchLoading: payload,
      };
    }
    case "RESET_FILTER": {
      return {
        ...state,
        sortBy: { filterName: "Sort By", filterOptionName: "", value: "" },
        priceRange: { filterName: "Price Range", range: null },
        filtersSelected: [],
        selectedCategories: [],
        fetchedCategories: [],
        availableProducts: false,
        loading: false,
        nutritionalFact: {
          calories: null,
          carbs: null,
          fats: null,
          protein: null,
          dietaryRestrictions: [],
        },
        allProductPriceRange: null,
        allProductNutritionFact: null,
        storeFilters: null,
        fetchLoading: false,
      };
    }
    case "FETCH_FILTERS": {
      const { layout, data } = payload;
      const { filtersSelected } = state;
      if (
        filtersSelected.length ||
        layout === "grid" ||
        layout === "grid2" ||
        layout === "scroll"
      ) {
        return {
          ...state,
          filtersSelected: [],
          sortBy: { filterName: "", filterOptionName: "", value: "" },
          priceRange: { filterName: "Price Range", range: null },
          selectedCategories: [],
          fetchedCategories: [],
          availableProducts: false,
          nutritionalFact: {
            calories: null,
            carbs: null,
            fats: null,
            protein: null,
            dietaryRestrictions: [],
          },
          allProductPriceRange: [data.price_range.min, data.price_range.max],
          allProductNutritionFact: data.nutrition_fact,
          storeFilters: data.filter_list,
        };
      }
      const filters = data.filter_list;
      const newFilters = [];
      filtersSelected.forEach((filter) => {
        const filterIndex = filters.findIndex(
          (item) => item.id === filter.parent_id
        );
        if (filterIndex !== -1) {
          const filterOptionIndex = filters[filterIndex].options.findIndex(
            (item) => item.id === filter.value
          );
          if (
            filters[filterIndex].type === filter.type &&
            filterOptionIndex !== -1
          ) {
            newFilters.push(filter);
          }
        }
      });
      return {
        ...state,
        filtersSelected: newFilters,
        sortBy: payload.sortByFilter
          ? state.sortBy
          : { filterName: "Sort By", filterOptionName: "", value: "" },
        priceRange: payload.priceFilter
          ? state.priceRange
          : { filterName: "Price Range", range: null },
        availableProducts: payload.availableProducts
          ? state.availableProducts
          : false,
        nutritionalFact: {
          calories: null,
          carbs: null,
          fats: null,
          protein: null,
          dietaryRestrictions: [],
        },
        allProductPriceRange: [data.price_range.min, data.price_range.max],
        allProductNutritionFact: data.nutrition_fact,
        storeFilters: data.filter_list,
      };
    }
    case "CLEAR_NUTRITIONAL_FACT": {
      return {
        ...state,
        nutritionalFact: {
          calories: null,
          carbs: null,
          fats: null,
          protein: null,
          dietaryRestrictions: [],
        },
      };
    }
    case "CHECK_FILTER_TYPE": {
      const { filters, layout } = payload;
      const { filtersSelected } = state;
      if (
        filtersSelected.length ||
        layout === "grid" ||
        layout === "grid2" ||
        layout === "scroll"
      ) {
        return {
          ...state,
          filtersSelected: [],
          sortBy: { filterName: "", filterOptionName: "", value: "" },
          priceRange: { filterName: "Price Range", range: null },
          selectedCategories: [],
          fetchedCategories: [],
          availableProducts: false,
          allProductPriceRange: null,
          allProductNutritionFact: null,
          storeFilters: null,
          fetchLoading: false,
          nutritionalFact: {
            calories: null,
            carbs: null,
            fats: null,
            protein: null,
            dietaryRestrictions: [],
          },
        };
      }
      const newFilters = [];
      filtersSelected.forEach((filter) => {
        const filterIndex = filters.findIndex(
          (item) => item.id === filter.parent_id
        );
        if (filterIndex !== -1) {
          const filterOptionIndex = filters[filterIndex].options.findIndex(
            (item) => item.id === filter.value
          );
          if (
            filters[filterIndex].type === filter.type &&
            filterOptionIndex !== -1
          ) {
            newFilters.push(filter);
          }
        }
      });
      return {
        ...state,
        filtersSelected: newFilters,
        sortBy: payload.sortByFilter
          ? state.sortBy
          : { filterName: "Sort By", filterOptionName: "", value: "" },
        priceRange: payload.priceFilter
          ? state.priceRange
          : { filterName: "Price Range", range: null },
        availableProducts: payload.availableProducts
          ? state.availableProducts
          : false,
        allProductPriceRange: null,
        allProductNutritionFact: null,
        storeFilters: null,
        fetchLoading: false,
      };
    }
    default:
      return state;
  }
};
